import styled from "styled-components";
import { palette } from "styled-theme";

const AppHolder = styled.div`
  .trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 16px;
    cursor: pointer;
    transition: color 0.3s;
  }

  .isomorphicContent{
    padding: 0px;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    background: rgb(248, 248, 250);
    position: relative;
  }

  /* Large screens — keep readable content widths and add side padding */
  @media (min-width: 1600px) {
    .isomorphicContent {
      padding: 0 24px;
    }
  }

  @media (min-width: 1920px) {
    .isomorphicContent {
      padding: 0 30px;
    }
  }

  @media (min-width: 2400px) {
    .isomorphicContent {
      padding: 0 30px;
    }
  }

  .trigger:hover {
    color: ${palette("primary", 0)};
  }

  .ant-layout-sider-collapsed .anticon {
    font-size: 16px;
  }

  .ant-layout-sider-collapsed .nav-text {
    display: none;
  }

  .ant-layout {
    background: #071821;

    &.isoContentMainLayout {
      overflow: hidden;
      padding: 0;
      width: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
    }
  }

  .isoLayoutContent {
    width: 100%;
    padding: 35px;
    background-color: #ffffff;
    border: 1px solid ${palette("border", 0)};
    height: 100%;
  }

  .isomorphicLayout {
    width: calc(100% - 240px);
    flex-shrink: 0;
    overflow-x: hidden !important;

    @media only screen and (max-width: 767px) {
      width: 100%;
    }

    @media only screen and (min-width: 768px) and (max-width: 1220px) {
      width: calc(100% - 80px);
    }
  }

  .ant-layout-footer {
    font-size: 13px;
    @media (max-width: 767px) {
      padding: 10px 20px;
    }
  }

  button {
    border-radius: 0;
  }

  @media (max-width: 767px) and (min-width: 320px) {
    .isomorphicContent {
      padding: 20px 0px 0px;
      flex-shrink: 0;
      background: rgb(248, 248, 250);
      position: relative;
    }
  }
    .page-spacing{
  padding-top: 0px;
}
`;

export default AppHolder;
